import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
  .rc-virtual-list-holder
     {

     }
  }
  
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #3249d7 !important;
    border-color: #3249d7 !important;
  }
  
  .ant-checkbox-inner {
    border-radius: 4px;
    width: 15px;
    height: 15px;
  }
  
  .ant-checkbox {
    top: inherit;
  }
  
  .ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-checked:hover .ant-checkbox-inner {
    background-color: #3249d7 !important;
    border-color: #3249d7 !important;
  }
  
  .ant-checkbox-checked::after {
    border: 1px solid #3249d7 !important;
  }
  
  .ant-checkbox-wrapper-checked .ant-checkbox-inner {
    background-color: #3249d7 !important;
    border-color: #3249d7 !important;
  }
`

export default GlobalStyle
